import { Component, Input } from "@angular/core";

@Component({
	selector: "app-data-change-indicator",
	templateUrl: "./data-change-indicator.component.html",
	styleUrls: ["./data-change-indicator.component.scss"],
})
export class DataChangeIndicatorComponent {
	@Input() icon: string;
	@Input() iconColor = "medium";
	@Input() text: string;
	@Input() textColor = "primary";
	@Input() isLoading = false;

	constructor() {}
}
